import type { ReactNode } from 'react';
import { cn } from '../../utils';
import { useContentProtection } from '../../hooks/use-content-protection';

const DEFAULT_WARNING =
  'Distribution of English2Empower materials is strictly prohibited and violates program policy.';
const DEFAULT_WATERMARK_TEXT = 'English2Empower • Confidential';

export type ProtectedContentShellProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  watermarkText?: string;
  warningMessage?: string;
  disableWatermark?: boolean;
  onPrintAttempt?: () => void;
};

export function ProtectedContentShell({
  children,
  className,
  contentClassName,
  watermarkText = DEFAULT_WATERMARK_TEXT,
  warningMessage = DEFAULT_WARNING,
  disableWatermark = false,
  onPrintAttempt,
}: ProtectedContentShellProps) {
  useContentProtection({
    warningMessage,
    onTrigger: onPrintAttempt,
  });

  const watermarkRows = disableWatermark ? 0 : 22;
  const watermarkCols = disableWatermark ? 0 : 14;

  return (
    <div className={cn('protected-shell', className)}>
      <div
        className={cn(
          'protected-content',
          contentClassName,
        )}
      >
        {!disableWatermark && (
          <div className="protected-watermark-grid" aria-hidden="true">
            {Array.from({ length: watermarkRows }).map((_, rowIndex) => (
              <div key={`watermark-row-${rowIndex}`} className="protected-watermark-row">
                {Array.from({ length: watermarkCols }).map((_, colIndex) => (
                  <span key={`watermark-cell-${rowIndex}-${colIndex}`}>{watermarkText}</span>
                ))}
              </div>
            ))}
          </div>
        )}
        {children}
      </div>
      <div className="protected-print-notice" aria-hidden="true">
        {warningMessage}
      </div>
    </div>
  );
}

export default ProtectedContentShell;

